"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var materialTheme = {
  themeName: 'Material'
};
exports.default = materialTheme;